/* eslint-disable import/no-named-as-default-member */
import TOKEN_UTIL from '../../../../../../util/token.customerAppSettings/scanline';
import { selectCustomerFromSurveys } from '../../../../AppAnalysisPage/selectors/surveys';
import { selectRootSliceCAS } from '../../../Main/selectors';
import { ROOT_SLICE } from '../constants';

export const selectThisSlice = state => { 
	const slice = selectRootSliceCAS(state);
	if (slice[ROOT_SLICE]) { 
		return slice[ROOT_SLICE];
	}

	// else assume state is already customer app settings.
	return state;
};


/**
 * META
 */

export const selectCustomer = (state) => {
	const slice = selectThisSlice(state);
	const { customer } = slice;
	return customer;
}

export const selectAnalysisPageCustomer = (state) => {
	const slice = selectThisSlice(state);
	const { analysisPageCustomer } = slice;
	return analysisPageCustomer;
}

export const selectCustomerSettingsSource = (state) => {
	const slice = selectThisSlice(state);
	const { customerSettingsSource } = slice;
	return customerSettingsSource;
}

export const selectIsLoading = (state) => { 
	const slice = selectThisSlice(state);
	const { isLoadingCustomerSettingsSource } = slice;
	return !!isLoadingCustomerSettingsSource;  
}

export const selectIsLoaded = (state) => { 
	const slice = selectThisSlice(state);
	const { isLoadedCustomerSettingsSource } = slice;
	return !!isLoadedCustomerSettingsSource;  
}



/**
 * IN APP REPORTS
 */

export const selectHasActionPlans = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableActionPlan(appSettingsOverride);
}

export const selectHasClosureReports = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableClosureReport(appSettingsOverride);
}


/**
 * TABS & LISTS PAGE - LINE LISTS
 */

export const selectHasTabLinesCardView = state => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableLinesListCardsView(appSettingsOverride);
};

export const selectHasTabLinesTableView = state => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableLinesListTableView(appSettingsOverride);
};

export const selectHasTabMyProjects = state => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableMyProjects(appSettingsOverride);
};


/**
 * TABS & LISTS PAGE - REPORTS LIST
 */

export const selectHasTabReports = state => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableReports(appSettingsOverride);
}

export const selectHasTabCustomReportsV1 = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV1(appSettingsOverride);
}

export const selectHasTabCustomReportsV2 = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableReportListActionPlanAndClosureV2(appSettingsOverride);
}

export const selectHasTabReportPercentPassing = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableReportPercentPassing(appSettingsOverride);
}

export const selectHasTabReportTotalMiles = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableReportTotalMiles(appSettingsOverride);
}

/**
 * MISCELLANEOUS SETTINGS
 */


export const selectHasSharedState = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableSharedStateForAnalysisAndReports(appSettingsOverride);
}

export const selectHasBehaviorAutoRemoveIliData = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingAutoRemoveIliData(appSettingsOverride);
}

export const selectHasFeatureEnablePsqlIliData = (state) => {   
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnablePsqlIliData(appSettingsOverride);
}

export const selectHasFeatureEnableTempUploadAutoRemove = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableTempUploadAutoRemove(appSettingsOverride);
}

export const selectHasFeatureEnablePersistLinkedSurveys = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnablePersistLinkedSurveys(appSettingsOverride);
}

export const selectHasFeatureClosureCopyActionPlan = (state) => {
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingFeatureClosureCopyActionPlan(appSettingsOverride);
}


/**
 * CUSTOMER CREATED JOBS
 */
export const selectHasCustomerCreatedJobs = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingEnableCustomerCreatedJobs(appSettingsOverride);
}

export const selectHasDefaultUploadsToSearchable = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.hasSettingDefaultUploadsToSearchable(appSettingsOverride);
}



/**
 * UPLOAD SETTINGS - derived - simplifying selectors names
 */

export const selectBlnHasSharedState = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.blnHasSharedState(appSettingsOverride);
}

export const selectBlnAutoRemoveILIUploads = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.blnAutoRemoveILIUploads(appSettingsOverride);
}

export const selectBlnAllowTemporaryUploads = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.blnAllowTemporaryUploads(appSettingsOverride);
}

export const selectBlnAllowSearchableUploads = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.blnAllowSearchableUploads(appSettingsOverride);
}

export const selectBlnDefaultUploadsToSearchable = (state) => { 
	const slice = selectThisSlice(state);
	const { settings: appSettingsOverride } = slice;
	return !!TOKEN_UTIL.blnDefaultUploadsToSearchable(appSettingsOverride);
}


/**
 * TARGA
 */

export const selectAutoSaveProjectEnabled = (state) => { 
	const customer = selectCustomerFromSurveys(state);
	return customer === 'Targa';
}


export default {
	selectThisSlice,

	// META
	selectCustomer,
	selectAnalysisPageCustomer,
	selectCustomerSettingsSource,
	selectIsLoading,
	selectIsLoaded,

	// IN APP REPORTS
	selectHasActionPlans,
	selectHasClosureReports,

	// TABS & LISTS PAGE - LINE LISTS
	selectHasTabLinesCardView,
	selectHasTabLinesTableView,
	selectHasTabMyProjects,

	// TABS & LISTS PAGE - REPORTS LIST
	selectHasTabReports,
	selectHasTabCustomReportsV1,
	selectHasTabCustomReportsV2,
	selectHasTabReportPercentPassing,
	selectHasTabReportTotalMiles,

	// MISCELLANEOUS SETTINGS
	selectHasSharedState,
	selectHasBehaviorAutoRemoveIliData,
	selectHasFeatureEnablePsqlIliData,
	selectHasFeatureEnableTempUploadAutoRemove,
	selectHasFeatureEnablePersistLinkedSurveys,
	selectHasFeatureClosureCopyActionPlan,

	// CUSTOMER CREATED JOBS
	selectHasCustomerCreatedJobs,
	selectHasDefaultUploadsToSearchable,

	// UPLOAD SETTINGS - derived - simplifying selectors names
	selectBlnHasSharedState,
	selectBlnAutoRemoveILIUploads,
	selectBlnAllowTemporaryUploads,
	selectBlnAllowSearchableUploads,
	selectBlnDefaultUploadsToSearchable,

	// TARGA 
	selectAutoSaveProjectEnabled,
};
